module.exports = __webpack_public_path__ + "img/certificate-kids-bg.fa08b0b3.png";